import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Paper,
  Button,
  Dialog,
  alertTitleClasses,
} from "@mui/material";
// import Image from '../img/intro_back.png';
import { useHistory } from "react-router-dom";
import Center from "./Center";
import ClearIcon from "@mui/icons-material/Clear";
import get_cid_url from "../lib/get_cid_url";
import Swal from "sweetalert2";
import send_webview_data from "../lib/send_webview_data";
import get_cid from "../lib/get_cid";

// import LoadingScreen from '../react-loading-screen';

// const styles = {
//     paperContainer: {
//       backgroundImage: `url(${Image})`,
//       backgroundSize: "cover",
//       backgroundPosition: "center"
//     }
//   };
// <LoadingScreen
//     loading={true}
//     backgroundImage={url({Image})}
//     backgroundSize="cover"
//     backgroundPosition="center"
// ></LoadingScreen>
// import styled from "styled-components";
// import Button from '@mui/material/Button';
// import Main from "../img/main.jpg";

// const Layout = styled.div`
//     /* display: flex;
//     flex-direction: column;
//     justify-content: space-around; */

//     .MainContainer {
//       height: 100vh;
//       display: flex;
//       flex-direction: column;
//       justify-content: space-around;
//       align-items: center;
//       align-content: center;
//       text-align: center;
//       background: url('/main.jpg') no-repeat;
//       background-size: cover;
//       color: white;
//   }
//     .mainheader {

//         /* justify-content: center; */
//     }
//     .spacebox {
//       height: 50px;
//     }
//     .maintext {
//       font-weight: bold;
//       font-size: 12px;
//       margin: 0 5px 5px;
//     }
/* .backimage{
    object-fit: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    background: no-repeat;
    background-size: cover;
} */
/* .contentcontainer {
    justify-content: space-between;
}
.mainheader {
    text-align: center;

}
.buttoncontainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
} */
// `;

// let cid = GetCid();

function Intro() {
  const history = useHistory();
  const cid = get_cid_url();

  const [openCenter, setOpenCenter] = useState(false);

  const clickOpenCenter = () => {
    setOpenCenter(true);
  };
  const clickCloseCenter = () => {
    setOpenCenter(false);
  };

  useEffect(() => {
    // 센터코드가 전달되어야 시작하도록 설정
    if (!window) return;
    if (cid !== "") {
      localStorage.setItem("cid", cid);
      let timer = setTimeout(() => {
        window.location.href = "/home";
      }, 2000);
    } else {
      window.location.href = "/?cid=CID00000009";
    }
  });

  const go_page = (id) => {
    if (id === 1) {
      window.location.href = "/?cid=" + "CID00000009";
    } // 정관검
    if (id === 2) {
      window.location.href = "/?cid=" + "CT17X10111035.huwy5";
    } // 고현점
    if (id === 3) {
      window.location.href = "/?cid=" + "CT14Z01170314.HXZb9";
    } // 옥포점
    if (id === 4) {
      window.location.href = "/?cid=" + "CID00000017";
    } // 옥포점
  };

  const styles = {
    paperContainer: {
      backgroundImage: `${
        cid === "CT14S15143839.Pdfg3"
          ? "url(./img/intro_test.png)"
          : "url(./img/intro_back.png)"
      }`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  };

  return (
    <Paper style={styles.paperContainer}>
      <Grid container height="100vh" direction="column">
        {/* { cid===''?
        <Box position="absolute" margin={1}>
          <Box>Stored CID : {get_cid()}</Box>
          <Box marginTop={1}>
            <Button variant="contained" onClick={()=>go_page(1)}>정관점 바로가기</Button>
          </Box>
          <Box marginTop={1}>
            <Button variant="contained" onClick={()=>go_page(2)}>고현점 바로가기</Button>
          </Box>
          <Box marginTop={1}>
            <Button variant="contained" onClick={()=>go_page(3)}>옥포점 바로가기</Button>
          </Box>                                      
        </Box>:null } */}

        <Grid
          container
          direction="column"
          // justifyContent="space-around"
          alignItems="center"
          height="100%"
        >
          <Grid
            container
            width="100%"
            justifyContent="center"
            alignItems="center"
          >
            {cid !== "CT14S15143839.Pdfg3" && (
              <>
                <Box sx={{ textAlign: "center" }}>
                  <img
                    src="./img/docircuit_logo.png"
                    style={{ width: "100%", marginTop: "50px" }}
                  />
                </Box>
                <Box>
                  <img
                    src="/img/intro_text.png"
                    style={{
                      position: "absolute",
                      bottom: "30px",
                      right: "15px",
                    }}
                  />
                </Box>
              </>
            )}
          </Grid>
          {/* <Grid>
          <Button variant="contained"
              style={{
                width: "100%",
                border: "solid 1px white",
                borderRadius: "50px",
                marginBottom: "5px",
                background: "rgba(247,147,15,0.9)",
                color: "black",
                marginTop: "5px",
                fontWeight: "bold"
                }}
                onClick={clickOpenCenter}>센터소개</Button>
                <Dialog
                fullScreen
                open={openCenter}
                onClose={clickCloseCenter}
                >
                  <Grid className="header"
                  container
                  direction="row"
                  justifyContent="space-between"
                  style={{
                    width: "100%",
                    padding: "5px",
                    fontSize: "20px",
                    background: "#0092a2",
                    color: "white",
                    zIndex: 10
                    }}>
                    센터소개
                    <ClearIcon onClick={clickCloseCenter}></ClearIcon>
                  </Grid>
                  <Center></Center>
                </Dialog>
            <Button variant="outliend"
              style={{
                width: "100%",
                border: "solid 1px black",
                borderRadius: "50px",
                background: "rgba(255,255,255,0.9)",
                color: "black",
                marginTop: "3px",
                fontWeight: "bold"
                }}
                onClick={() => history.push('/home')}>시작하기</Button>
                </Grid> */}
        </Grid>
      </Grid>
    </Paper>
    // <Layout>
    //     <div className="MainContainer">
    //       <div className="mainheader">
    //         <div className="spacebox"></div>
    //         <img src={require("../img/main_logo_white.png").default} style={{width: "80%"}} />
    //         <div className="maintext">
    //           프리미엄 그룹PT
    //           <br></br>
    //           두써킷
    //         </div>
    //       </div>
    //     <div className="buttoncontainer">
    //      <Button variant="contained"
    //           style={{
    //             width: "100%",
    //             border: "solid 1px white",
    //             borderRadius: "50px",
    //             marginBottom: "5px",
    //             background: "rgba(247,147,15,0.9)",
    //             color: "black",
    //             marginTop: "5px",
    //             fontWeight: "bold"
    //             }}>시설소개</Button>
    //         <Button variant="outliend"
    //           style={{
    //             width: "100%",
    //             border: "solid 1px black",
    //             borderRadius: "50px",
    //             background: "rgba(255,255,255,0.9)",
    //             color: "black",
    //             marginTop: "3px",
    //             fontWeight: "bold"
    //             }}>시작하기</Button>
    //             <div className="spacebox"></div>
    //         </div>
    //       </div>
    // </Layout>
  );
}

export default Intro;
